import { LAYER, LAYER_PROPS, LAYER_ZINDEX } from 'constants/Constants';
import { Feature } from 'ol';
import { Coordinate } from 'ol/coordinate';
import { Geometry, MultiPolygon, Point } from 'ol/geom';
import Polygon from 'ol/geom/Polygon';
import Layer from 'ol/layer/Layer';
import VectorLayer from "ol/layer/Vector";
import VectorSource from 'ol/source/Vector';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Text from 'ol/style/Text';
import { mapStore } from 'stores/Map';
import { SystemStore } from "stores/System";

let kamcoTextLayers: Map<string, Layer> = new Map();

export const useKamcoTextLabels = () => {
    const { map } = mapStore();
    const { isKamcoDemo } = SystemStore();

    const addKamcoTextLabels = (features: Feature<Geometry>[], layerName: string, text: '4차' | '6차') => {
        if (!map) return;
        
        let textLayer = kamcoTextLayers.get(layerName);
        if (!textLayer) {
            const textSource = new VectorSource();
            textLayer = new VectorLayer({
                source: textSource,
                zIndex: LAYER_ZINDEX.FEATURE + 1,
                style: (feature, resolution) => {
                    const zoom = map?.getView().getZoom();
                    if (!zoom || zoom < 17) {
                        return undefined;
                    }
                    return new Style({
                        text: new Text({
                            text,
                            font: 'bold 14px sans-serif',
                            fill: new Fill({
                                color: '#000000',
                            }),
                            stroke: new Stroke({
                                color: '#FFFFFF',
                                width: 3,
                            }),
                            textBaseline: 'bottom',
                            offsetY: -5,
                        }),
                    });
                },
            });
            textLayer.set(LAYER_PROPS.LAYER_TYPE, text === '6차' ? LAYER.KAMCO_CUSTOM_LAYER : LAYER.RESULT_LAYER);
            textLayer.set(LAYER_PROPS.LAYER_NAME, layerName);
            map.addLayer(textLayer);
            kamcoTextLayers.set(layerName, textLayer);
        }
        
        if (!textLayer) return;
        const source = textLayer.getSource();
        if (!source) return;
        
        features.forEach((feature) => {
            const geometry = feature.getGeometry();
            if (!geometry) return;
            
            let topCoordinate: Coordinate | null = null;
            
            if (geometry instanceof Polygon) {
                const extent = geometry.getExtent();
                const centerX = (extent[0] + extent[2]) / 2;
                const topY = extent[3];
                topCoordinate = [centerX, topY];
            } else if (geometry instanceof MultiPolygon) {
                const extent = geometry.getExtent();
                const centerX = (extent[0] + extent[2]) / 2;
                const topY = extent[3];
                topCoordinate = [centerX, topY];
            }
            
            if (topCoordinate) {
                const textFeature = new Feature({
                    geometry: new Point(topCoordinate),
                });
                (source as unknown as VectorSource).addFeature(textFeature);
            }
        });
    };

    const updateTextLayerVisible = (layerName: string, is: boolean) => {
        if (!isKamcoDemo) return;
        const textLayer = kamcoTextLayers.get(layerName);
        if (textLayer) {
            textLayer.setVisible(is);
        }
    };

    const clearTextLayers = () => {
        kamcoTextLayers.forEach((textLayer) => {
            const source = textLayer.getSource();
            if (source) {
                (source as unknown as VectorSource).clear();
            }
            map?.removeLayer(textLayer);
        });
        kamcoTextLayers.clear();
    };

    return {
        addKamcoTextLabels,
        updateTextLayerVisible,
        clearTextLayers
    };
};
